import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, Tabs } from 'antd';

import { changeTab } from '@store/modules/incubator/incu_custom_list';
import ConditionSearch from '@comm/search/ConditionSearch.js';
import TableEnter from './TableEnter';
import TableOut from './TableOut';

const { TabPane } = Tabs;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = { condition: props.condition }; // 从redux中获取调用列表的条件
  }

  componentDidMount() {
    const { condition } = this.props;
    // 当前孵化器与redux记录不是同一个时，条件置空
    if (condition.incubatorUuid !== this.props.params.uuid) {
      this.setState({
        condition: {
          incubatorUuid: this.props.params.uuid,
          condition: '',
        },
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    // 切换孵化器时，条件置空
    if (nextProps.params.uuid !== this.props.condition.incubatorUuid) {
      this.setState({
        condition: {
          incubatorUuid: nextProps.params.uuid,
          condition: '',
        },
      });
    }
  }

  callback = key => {
    this.key = key;
    this.props.dispatch(changeTab(key));
  };

  onSearch = params => {
    this.setState({
      condition: { incubatorUuid: this.props.params.uuid, ...params },
    });
  };

  render() {
    const { tab } = this.props;
    const { condition } = this.state;
    return (
      <Card title="客户管理">
        <Tabs
          defaultActiveKey={tab || '1'}
          onChange={this.callback}
          tabBarExtraContent={
            <ConditionSearch
              export
              {...this.props}
              initialValue={condition.condition}
              onChange={this.onSearch}
              fieldName="condition"
              loading={this.props.residentCustomerLoading || this.props.incubatingCustomerLoading}
            />
          }
        >
          <TabPane tab="签约客户" key="1">
            <TableEnter {...this.props} condition={condition} />
          </TabPane>
          <TabPane tab="出孵客户" key="2">
            <TableOut {...this.props} condition={condition} />
          </TabPane>
        </Tabs>
      </Card>
    );
  }
}

export default connect(state => ({
  tab: state.incu_custom_list.tab,
  condition: state.incu_custom_list.condition,
  residentCustomerLoading: state.incu_custom_list.residentCustomerLoading,
  incubatingCustomerLoading: state.incu_custom_list.incubatingCustomerLoading,
}))(Index);



// WEBPACK FOOTER //
// ./src/components/incubator/custom/CompentCustom.js